// extracted by css-extract-rspack-plugin
export default {"legal":"legal--u0vY4mnpNnwUvow9"};